<template>
  <div class="MerchantSettled">
    <div style="height:15px;"></div>
    <div class="w MerchantSettled_box">
      <div class="MerchantSettled_title">免费发布需求，优选服务商为您服务</div>
      <div style="margin: 0 auto; width: 1000px">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" class="demo-ruleForm">
          <div class="littleTitleBox">
            <div class="littleTitle_text">需求信息</div>
            <div class="littleTitle_line"></div>
          </div>
          <div class="infoBox">
            <el-form-item label="选择您的需求" prop="demandGoods.demandType" class="infoItem">
              <div class="satelliteWrap">
                <el-radio-group v-model="ruleForm.demandGoods.demandType" @change="demandselect">
                  <el-radio-button v-for="(item,index) in demandButtons" :key="index" :label="item.value">
                    {{item.name}}
                  </el-radio-button>
                </el-radio-group>
              </div>
            </el-form-item>
            <el-form-item label="选择需求行业" class="infoItem" v-if="industryButtonsCheckedShow">
              <div class="satelliteWrap">
                <el-radio-group v-model="ruleForm.demandGoods.productPlateId">
                  <el-radio-button v-for="(item,index) in industryButtons" :key="index" :label="item.id">
                    {{item.plateName}}
                  </el-radio-button>
                </el-radio-group>
              </div>
            </el-form-item>
            <el-form-item label="需求标题" prop="demandGoods.demandTitle" class="infoItem">
              <el-input v-model="ruleForm.demandGoods.demandTitle" placeholder="请输入需求标题" :controls="false" style="width: 80%"></el-input>
            </el-form-item>
            <el-form-item label="需求描述" prop="demandGoods.demandDescribe" class="infoItem">
              <el-input type="textarea" rows="5" maxlength="1000" show-word-limit v-model="ruleForm.demandGoods.demandDescribe" style="width: 80%" placeholder="请输入需求描述"></el-input>
            </el-form-item>
            <el-form-item label="预算区间" prop="demandGoods.minBudget" class="infoItem">
              <el-input type="number" v-model="ruleForm.demandGoods.minBudget" placeholder="请输入最低预算" style="width: 35%"></el-input>
              元 -
              <el-input type="number" v-model="ruleForm.demandGoods.maxBudget" placeholder="请输入最高预算" style="width: 35%"></el-input> 元
            </el-form-item>
          </div>

          <div class="littleTitleBox">
            <div class="littleTitle_text">企业基本信息</div>
            <div class="littleTitle_line"></div>
          </div>
          <el-form-item label="企业名称" prop="demandGoods.enterpriseName" class="infoItem">
            <el-input v-model="ruleForm.demandGoods.enterpriseName" placeholder="请输入企业名称" style="width: 80%"></el-input>
          </el-form-item>
          <el-form-item label="所在地区" prop="address" class="infoItem">
            <citySingle @getCityInfo="getCityInfoFun"  :sendCityInfo="[ruleForm.demandGoods.countryName,ruleForm.demandGoods.provinceName,ruleForm.demandGoods.cityName,ruleForm.demandGoods.countyName]"  style="width: 80%"></citySingle>
          </el-form-item>
          <el-form-item label="详细地址" prop="demandGoods.address" class="infoItem">
            <el-input v-model="ruleForm.demandGoods.address" placeholder="请输入详细地址" style="width: 80%"></el-input>
          </el-form-item>
          <el-form-item label="联系人" prop="demandGoods.contactName" class="infoItem">
            <el-input v-model="ruleForm.demandGoods.contactName" placeholder="请输入联系人" style="width: 80%"></el-input>
          </el-form-item>
          <el-form-item label="手机号码" prop="demandGoods.phoneNumber" class="infoItem">
            <el-input v-model="ruleForm.demandGoods.phoneNumber" placeholder="请输入手机号码" style="width: 80%"></el-input>
          </el-form-item>
          <!-- <el-form-item label="验证码" prop="code" class="infoItem">
            <div class="verification_code flex-be">
              <el-input class="m-r-5" v-model="ruleForm.code" placeholder="请输入验证码" style=""></el-input>
              <smsSend :mobile="ruleForm.demandGoods.phoneNumber" :sms-type="'PUSH_DEMAND'"></smsSend>
            </div>
          </el-form-item> -->
          <div class="showwarning">
            注：您的需求提交后，为保证服务质量，我们会尽快与您取得联系。平台会严密保护您的个人信息及信息隐私，请您放心填写。
          </div>
          <el-form-item v-if="editview">
            <el-button type="primary" @click="submitForm('ruleForm')"> {{ruleForm.demandGoods.id?"提交":"立即创建" }}</el-button>
            <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div style="height:20px;"></div>
  </div>
</template>

<script>
  import citySingle from "@/components/citySingle.vue";
  import smsSend from "@/components/SmsSend";
  export default {
    components: {
      citySingle,
      smsSend
    },
    data() {

      return {
        demandButtons: [{
            value: 1,
            name: '影像数据'
          },
          {
            value: 2,
            name: '数据产品'
          },
          {
            value: 3,
            name: '软件工具'
          },
          {
            value: 4,
            name: '其他产品'//'接口服务',
          }
        ],
        industryButtons: [],
        industryButtonsCheckedShow: false,
        ruleForm: {
          "code": "", //短信验证码
          "demandGoods": {
            "demandType": 1, //需求类别
            "address": "", //地址
            // "checkTime": "",//	审核时间
            // "checkUserId": "",//	审核ren
            "cityId": 0, //	市id
            "contactName": "", //	联系人姓名
            "countyId": 0, //	县id
            "demandDescribe": "", //	需求描述
            "demandTitle": "", //需求标题
            "enterpriseName": "", //	公司名称
            // "id": "",
            "maxBudget": 0, //	最高预算
            "minBudget": 0, //		最低预算
            "phoneNumber": "", //	联系人手机号
            "productPlateId": "", //产品板块，行业id ;
            "provinceId": 0, //省id
            // "publishTime": "",//发布时间
            // "publishUserId": "",//发布人id
            // "status": 0,//状态：0.待审核；1.审核通过；2.审核不通过；
            // "updateTime": "" //修改时间
          }
        },
        rules: {
          // demandType: [{ required: true, message: "请选择需求类别", trigger: "change" }],
          'demandGoods.demandDescribe': [{ required: true, message: "请输入需求描述", trigger: "blur" }],
          'demandGoods.demandTitle': [{ required: true, message: "请输入需求标题", trigger: "blur" }],
          'demandGoods.minBudget': [{ required: true, message: "请输入预算区间", trigger: "blur" }],
          // code: [{ required: true, message: "请输入短信验证码", trigger: "blur" }],
          'demandGoods.enterpriseName': [{ required: true, message: "请输入企业名称", trigger: "blur" }],
          'demandGoods.address': [{ required: true, message: "请输入地址", trigger: "blur" }],
          'demandGoods.contactName': [{ required: true, message: "请输入联系人", trigger: "blur" }],
          'demandGoods.phoneNumber': [{ required: true, message: "请输入手机号码", trigger: "blur" }],
        },
        editview:true,
      };
    },
    mounted() {
      console.log(this.$route.query.id,111);
      if(this.$route.query.id){
        this.editview= this.$route.query.edit;
         // 查看详情
       this.$http.get(this.$const.personalCenter.demandView+this.$route.query.id).then((res) => {
        if (res.code === 200) {
          this.ruleForm.demandGoods = res.data;
              this.demandselect(this.ruleForm.demandGoods.demandType )
          
        }
      })
      
      }
      

      // 获取需求行业
      this.$http.get(this.$const.MerchantWorkbench.GetlistProductSections).then((res) => {
        if (res.code === 200) {
          this.industryButtons = res.data;
        }
      })
    },
    methods: {
      // 获取省市区信息
      getCityInfoFun(value) {
        // console.log('获取省市区信息', value);
        this.ruleForm.countryId = value[0];
        this.ruleForm.demandGoods.provinceId = value[1];
        this.ruleForm.demandGoods.cityId = value[2];
        this.ruleForm.demandGoods.countyId = value[3];
      },
      demandselect(val) {
        if (val == 1) {
          this.ruleForm.demandGoods.productPlateId = '';
          this.industryButtonsCheckedShow = false;
        } else {
          this.industryButtonsCheckedShow = true;
        }
        // console.log(this.ruleForm.demandGoods.demandType, val)
      },


      submitForm(formName) {
        this.$refs[formName].validate(async (valid) => {
          if (valid) {
            // console.log(this.ruleForm);
            if(this.$route.query.id){
              try {
              let res = await this.$http.post(this.$const.personalCenter.demandupdate, this.ruleForm.demandGoods)
              if (res.code === 200) {
                this.$message.success('发布需求成功')
                var that = this;
                setTimeout(function() {
                  // that.$router.go(-1)
                  this.$router.push({
                    name: 'buyerCenter',
                    query: {
                      type: 'xuqiuManage'
                    }
                  })
                }, 3000)
              }
            } catch (e) {
              // this.$message.error(e)
            }
            }else{
              try {
              let res = await this.$http.post(this.$const.RemoteSensingMall.demandFB, this.ruleForm)
              if (res.code === 200) {
                this.$message.success('发布需求成功')
                var that = this;
                setTimeout(function() {
                  // that.$router.go(-1)
                  that.$router.push({
                    name: 'buyerCenter',
                    query: {
                      type: 'xuqiuManage'
                    }
                  })
                }, 3000)
              }
            } catch (e) {
              // this.$message.error(e)
            }
            }
          
          } else {
            // console.log("error submit!!");
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .MerchantSettled_box {
    padding: 20px;
    background: #fff;
    box-shadow: 0px 0px 5px #ccc;
  }

  .infoItem {
    width: 100%;
  }

  .infoBox {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
  }

  .littleTitle_line {
    flex: 1;
    border-bottom: 2px solid #ccc;
    height: 30px;
    line-height: 30px;
  }

  .littleTitle_text {
    color: #1890ff;
    height: 30px;
    line-height: 30px;
    padding: 0 20px;
    border-bottom: 2px solid #1890ff;
  }

  .littleTitleBox {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }

  .showwarning {
    color: #f44336;
    padding-left: 65px;
    margin-bottom: 20px;
    font-size: 14px;
  }

  /deep/ #phone input {
    text-align: left !important;
  }

  .MerchantSettled_title {
    text-align: center;
    font-size: 28px;
    margin: 25px 0 50px;
    color: #555;
  }

  .MerchantSettled {
    background: #eff2f7;
  }

  .btnSale {
    display: flex;
    flex-wrap: wrap;

    div {
      padding: 0px 15px;
      color: #666666;
      background: none;
      cursor: pointer;
      // transition: all .3s;
      border: 1px solid rgba(204, 204, 204, .9);
      height: 36px;
      line-height: 36px;

    }

    .isclick {
      color: #3868e9;
      background: #3867e90a;
      border: 1px solid #3868e9;
      position: relative;
    }

    .isclick::after {
      content: '';
      // display: block;
      position: absolute;
      top: -1px;
      left: -1px;
      width: 10px;
      height: 10px;
      background-image: url('../../assets/imgs/home/rightJiao.svg');
    }

  }

  .satelliteWrap {
    flex: 12;
  }

  .satelliteSonClass {
    display: flex;
    margin-top: 10px;
    border-bottom: 1px solid #eeeeee;

    .satelliteTitle {
      display: inline-block;
      width: 80px;
      font-size: 17px;
      font-weight: 600;
      text-align: justify;
      text-align-last: justify;
      color: #444;
      margin-right: 10px;
    }

    .satelliteWrap {
      flex: 12;
    }
  }

  .satelliteIndustry {
    display: flex;
    margin-top: 10px;
    border-bottom: 1px solid #eeeeee;

    .satelliteTitle {
      display: inline-block;
      width: 80px;
      font-size: 17px;
      font-weight: 600;
      text-align: justify;
      text-align-last: justify;
      color: #444;
      margin-right: 10px;
    }

    .satelliteWrap {
      flex: 12;
    }
  }

  .satelliteResolve {
    display: flex;
    margin-top: 10px;
    border-bottom: 1px solid #eeeeee;

    .satelliteTitle {
      display: inline-block;
      width: 80px;
      font-size: 17px;
      font-weight: 600;
      text-align: justify;
      text-align-last: justify;
      color: #444;
      margin-right: 10px;
    }

    .satelliteWrap {
      flex: 12;
    }
  }

  .satelliteLevel {
    display: flex;
    margin-top: 10px;
    border-bottom: 1px solid #eeeeee;

    .satelliteTitle {
      display: inline-block;
      width: 80px;
      font-size: 17px;
      font-weight: 600;
      text-align: justify;
      text-align-last: justify;
      color: #444;
      margin-right: 10px;
    }

    .satelliteWrap {
      flex: 12;
    }
  }

  .satelliteWrap /deep/ .el-radio-button {
    margin: 0px 10px 2px !important;
  }

  .satelliteWrap /deep/ .el-checkbox-button {
    margin: 0px 10px 2px !important;
  }

  .satelliteWrap /deep/ .el-radio-button .el-radio-button__inner {
    border: 0px !important;
    border-radius: 0% !important;
    padding: 8px !important;
    border: 1px solid rgb(231, 227, 227) !important;
  }

  .satelliteWrap /deep/ .el-checkbox-button .el-checkbox-button__inner {
    border: 0px !important;
    border-radius: 0% !important;
    padding: 8px !important;
    border: 1px solid #fff !important;
  }

  .satelliteWrap /deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner {
    color: #3868e9;
    background: #3867e90a !important;
    border: 1px solid #3868e9 !important;
    transition: none !important;
    box-shadow: none !important;
  }

  .satelliteWrap /deep/ .el-checkbox-button.is-checked .el-checkbox-button__inner {
    color: #3868e9;
    background: #3867e90a !important;
    border: 1px solid #3868e9 !important;
    transition: none !important;
    box-shadow: none !important;
  }

  .satelliteWrap /deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner::after {
    content: '';
    position: absolute;
    top: -1px;
    left: -1px;
    width: 10px;
    height: 10px;
    background-image: url(/img/rightJiao.c55916ca.svg);
  }

  .satelliteWrap /deep/ .el-checkbox-button.is-checked .el-checkbox-button__inner::after {
    content: '';
    position: absolute;
    top: -1px;
    left: -1px;
    width: 10px;
    height: 10px;
    background-image: url(/img/rightJiao.c55916ca.svg);
  }

  .verification_code {
    width: 80%;
    height: 40px;
  }
</style>
